import React from 'react';
import { ShieldCheck, Download, Zap, CreditCard, Award, CheckCircle2, Truck, Headphones } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { CountdownTimer } from './CountdownTimer';
export function PricingSection() {
  return <section id="comprar" className="bg-gradient-to-b from-yellow-50 to-orange-100 py-20 px-4 relative overflow-hidden" data-id="element-207">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-20 bg-white" style={{
      clipPath: 'ellipse(50% 100% at 50% 0%)'
    }} data-id="element-208"></div>

      <div className="max-w-4xl mx-auto bg-white rounded-[3rem] shadow-2xl overflow-hidden border-8 border-yellow-300 relative z-10" data-id="element-209">
        {/* Badge */}
        <div className="absolute top-0 right-0 bg-red-500 text-white font-black px-8 py-3 rounded-bl-3xl z-10 shadow-md text-lg" data-id="element-210">
          -80% DESCUENTO
        </div>

        <div className="p-8 md:p-16 text-center" data-id="element-211">
          <h2 className="text-3xl md:text-5xl font-black text-gray-900 mb-4 leading-tight" data-id="element-212">
            ¡Obtén Todo el Mega Pack + <br className="hidden md:block" data-id="element-213" />
            <span className="text-green-500" data-id="element-214">Bonos GRATIS!</span>
          </h2>

          <p className="text-gray-600 text-lg mb-8 font-medium" data-id="element-215">
            Únete a más de 1,500 padres felices que ya están disfrutando de
            tiempo de calidad sin pantallas.
          </p>

          {/* Pricing Box */}
          <div className="bg-orange-50 rounded-3xl p-8 mb-10 border-2 border-orange-200 inline-block w-full max-w-2xl relative overflow-hidden" data-id="element-216">
            {/* Urgency Ribbon inside box */}
            <div className="absolute top-0 left-0 w-full bg-red-100 text-red-600 text-xs font-bold py-2 uppercase tracking-widest" data-id="element-217">
              Oferta por tiempo limitado
            </div>

            <div className="mt-6 flex flex-col md:flex-row justify-center items-center gap-4 md:gap-8 mb-6" data-id="element-218">
              <div className="text-center opacity-60" data-id="element-219">
                <p className="text-gray-600 font-bold text-lg" data-id="element-220">
                  Precio Regular
                </p>
                <p className="text-3xl font-bold text-gray-500 line-through decoration-red-500 decoration-4" data-id="element-221">
                  $89,990
                </p>
              </div>
              <div className="hidden md:block h-16 w-1 bg-orange-200 rounded-full" data-id="element-222"></div>
              <div className="text-center transform scale-110" data-id="element-223">
                <p className="text-green-600 font-bold text-lg animate-pulse" data-id="element-224">
                  OFERTA HOY
                </p>
                <p className="text-6xl md:text-7xl font-black text-gray-900 tracking-tight" data-id="element-225">
                  $19,990
                </p>
              </div>
            </div>

            <div className="bg-green-100 text-green-800 font-bold py-2 px-6 rounded-full inline-block mb-8 shadow-sm border border-green-200" data-id="element-226">
              ¡Ahorras $70,000 hoy!
            </div>

            <CountdownTimer data-id="element-227" />

            <CTAButton text="¡SÍ, QUIERO MI MEGA PACK AHORA!" subtext="Descarga Inmediata • Pago Seguro" className="w-full shadow-orange-500/30" href="https://recursoseducapro.shop/cart/47652553720046:1" data-id="element-228" />

            {/* Platinum Seller Badge */}
            <div className="mt-8 bg-white rounded-xl p-4 border border-gray-200 shadow-sm flex flex-col items-center" data-id="element-229">
              <div className="flex items-center gap-2 mb-2" data-id="element-230">
                <Award className="w-6 h-6 text-yellow-500 fill-yellow-500" data-id="element-231" />
                <span className="text-green-600 font-bold text-lg" data-id="element-232">
                  Vendedor Platinum
                </span>
              </div>
              <p className="text-gray-500 text-sm font-medium mb-3" data-id="element-233">
                Más de 10,000 ventas exitosas
              </p>
              <div className="flex flex-wrap justify-center gap-3 text-xs text-gray-600 font-medium" data-id="element-234">
                <span className="flex items-center gap-1" data-id="element-235">
                  <CheckCircle2 className="w-3 h-3 text-green-500" data-id="element-236" /> Envío
                  inmediato
                </span>
                <span className="flex items-center gap-1" data-id="element-237">
                  <Headphones className="w-3 h-3 text-green-500" data-id="element-238" /> Soporte 24/7
                </span>
                <span className="flex items-center gap-1" data-id="element-239">
                  <ShieldCheck className="w-3 h-3 text-green-500" data-id="element-240" /> Garantía de
                  satisfacción
                </span>
              </div>
            </div>
          </div>

          {/* Guarantee */}
          <div className="flex flex-col md:flex-row items-center justify-center gap-6 max-w-2xl mx-auto bg-blue-50 p-6 rounded-2xl border-2 border-blue-100 border-dashed" data-id="element-241">
            <ShieldCheck className="w-16 h-16 text-blue-500 flex-shrink-0" data-id="element-242" />
            <div className="text-left" data-id="element-243">
              <h4 className="font-bold text-lg text-gray-900 mb-1" data-id="element-244">
                Garantía de Satisfacción de 7 Días
              </h4>
              <p className="text-sm text-gray-600" data-id="element-245">
                Si no estás 100% satisfecho con el material, te devolvemos tu
                dinero sin preguntas. Tu compra está totalmente protegida.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}